
























































import Vue from 'vue'
import { CategoryTreeNodeType } from '../../models/CategoryTreeNode'
export default Vue.extend({
  name: 'NovaCategoryPostTree',
  props: {
    categoryTree: {
      type: Array
    }
  },
  methods: {
    nodeIsPost(type: CategoryTreeNodeType) {
      return type === CategoryTreeNodeType.Post
    }
  }
})
